import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/feed/categories/")({
  component: () => <div>Hello /_authenticated/app/feed/categories/!</div>,
});
